// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.baloa-play-full-video-modal.modal2 {
    background-color: rgba(0, 0, 0, 0.9);
}

.baloa-play-full-video-modal .modal2__container {
    width: 90%;
    height: 90%;
    box-shadow: none;
}

.baloa-play-full-video-modal .modal2__header {
    background: transparent;
    color: var(--white-color);
    border-bottom: none;
}

.baloa-play-full-video-modal .modal2__header__title.baloa-subtitle-2 {
    color: var(--white-color) !important;
    font-size: 30px;
    font-weight: 700;
}

.baloa-play-full-video-modal .modal2__header__close_icon {
    color: var(--white-color);
    padding: 5px;
    background: var(--primary-dark-color);
    border-radius: 50%;
    font-size: 40px;
}

.baloa-play-full-video-modal .modal2__content {
    background: transparent;
    padding-top: 60px;
}


.baloa-play-full-video-modal__container{
    display: flex;
    align-items: flex-start;
    gap: 10px;
    width: 100%;
    justify-content: space-between;
}

.baloa-play-full-video-modal__media-container {
    position: relative;
    width: 100%;
    height: auto;
}

.baloa-play-full-video-modal__video-container {
    position: relative;
    width: 100%;
    height: 100vh;
    text-align: center;
}

.baloa-play-full-video-modal__slide-button {
    height: 100%;
    display: flex;
    align-items: center;
    width: 5%;
    cursor: pointer;
    z-index: 2;
}

.baloa-play-full-video-modal__slide-button.disabled{
    opacity: 0.5;
}

.baloa-play-full-video-modal__slide-button .hubicon-arrow_circle_right {
    font-size: 50px;
    font-weight: var(--font-bold);
    margin-left: auto;
}

.baloa-play-full-video-modal__slide-button .hubicon-arrow_circle_right .path1::before {
    color: var(--primary-dark-color);
}

.baloa-play-full-video-modal__slide-button .hubicon-arrow_circle_left {
    font-size: 50px;
    font-weight: var(--font-bold);
}

.baloa-play-full-video-modal__slide-button .hubicon-arrow_circle_left .path1::before {
    color: var(--primary-dark-color);
}

.baloa-play-full-video-modal__create-clip-button {
    position: absolute;
    top: 9vh;
    left: 50%;
    margin-left: -60px;
    z-index: 2000;
}

.baloa-play-full-video-modal__create-clip-button .button {
    width: 100%;
    padding: 12px 24px;
}

.baloa-play-full-video-modal__create-clip-button .button .icon {
    grid-area: icon;
    margin-right: 8px;
}

.baloa-play-full-video-modal__create-clip-button .hubicon-video_library-1::before {
    color: var(--white-color);
}

.baloa-play-full-video-modal__create-clip-widget__container {
    background: var(--white-color);
    border-radius: 8px;
    padding: 18px;
    min-width: 400px;
}

.baloa-play-full-video-modal__create-clip-widget__container .baloa-normal-medium {
    text-align: center;
    color: var(--primary-very-dark-color);
}

.baloa-play-full-video-modal__create-clip-widget__step {
    margin-top: 16px;
}

.baloa-play-full-video-modal__create-clip-widget__step.baloa-names {
    font-weight: var(--font-regular);
    color: var(--primary-very-dark-color);
}

.baloa-play-full-video-modal__create-clip-widget__button {
    margin-top: 16px;
}

.baloa-play-full-video-modal__create-clip-widget__button .button {
    padding: 12px 24px;
    width: 100%;
}

.baloa-play-full-video-modal__create-clip-widget__button .button .icon {
    grid-area: icon;
    margin-right: 8px;
    justify-self: flex-end;
}

.baloa-play-full-video-modal__create-clip-widget__button .button.button-red {
    background-color: #F1AEB5;
    color: #B02A37;
}

.baloa-play-full-video-modal__create-clip-widget__button .hubicon-stop_circle::before {
    color: #B02A37;
    font-size: 24px;
}

.baloa-play-full-video-modal__create-clip-widget__counter {
    border-radius: 4px;
    background: var(--new-informative-banner-bg-color);
    padding: 4px;
    text-align: center;
    width: 70%;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 16px;
}

.baloa-play-full-video-modal__create-clip-widget__counter .baloa-table {
    color: var(--primary-dark-color);
    text-wrap: nowrap;
}

.baloa-play-full-video-modal__create-clip-widget__counter .baloa-table.seconds {
    font-weight: var(--font-medium);
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */ 

    .baloa-play-full-video-modal .modal2__container {
        width: 100%;
        margin: 0;
        height: 100%;
        max-height: unset;
    }

    .baloa-play-full-video-modal .modal2__header {
        justify-content: flex-end;
        padding: 13px 15px;
    }

    .baloa-play-full-video-modal .modal2__header__title.baloa-subtitle-2 {
        display: none;
    }

    .baloa-play-full-video-modal .modal2__header__close_icon {
        background: none;
        margin-left: auto;
        padding: 0;
        font-size: 24px;
    }

    .baloa-play-full-video-modal .modal2__content {
        padding-top: 0;
    }

    .baloa-play-full-video-modal__media-container {
        width: 90%;
        height: inherit;
    }

    .baloa-play-full-video-modal__slide-button {
        width: 5%;
    }

    .baloa-play-full-video-modal__slide-button .hubicon-arrow_circle_left {
        font-size: 30px;
        position: fixed;

    }

    .baloa-play-full-video-modal__slide-button .hubicon-arrow_circle_right {
        font-size: 30px;
        position: fixed;
        right: 0px;
    }

    .baloa-play-full-video-modal__container {
        gap: 0;
        height: 90vh;
    }

    .baloa-play-full-video-modal__video-container {
        width: 100%;
        margin: auto;
        height: 100%;
    }

    .baloa-play-full-video-modal__create-clip-widget__container {
        position: absolute;
        bottom: 0;
        border-radius: 0;
        min-width: unset;
        width: 100%;
        padding: 12px;
    }

    .baloa-play-full-video-modal__media-container.create-clip {
        width: 100%;
        height: 50vh;
    }

}`, "",{"version":3,"sources":["webpack://./src/app/baloa-play/components/baloa-play-full-video-modal-component/BaloaPlayFullVideoModalComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;AACxC;;AAEA;IACI,UAAU;IACV,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;IACpC,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,qCAAqC;IACrC,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,iBAAiB;AACrB;;;AAGA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,WAAW;IACX,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,6BAA6B;IAC7B,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,qCAAqC;AACzC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;IAChC,qCAAqC;AACzC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,kDAAkD;IAClD,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;IAChC,iBAAiB;AACrB;;AAEA;IACI,+BAA+B;AACnC;;AAEA,yCAAyC,4BAA4B;;IAEjE;QACI,WAAW;QACX,SAAS;QACT,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,yBAAyB;QACzB,kBAAkB;IACtB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;QACjB,UAAU;QACV,eAAe;IACnB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,UAAU;QACV,eAAe;IACnB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,eAAe;QACf,eAAe;;IAEnB;;IAEA;QACI,eAAe;QACf,eAAe;QACf,UAAU;IACd;;IAEA;QACI,MAAM;QACN,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,gBAAgB;QAChB,gBAAgB;QAChB,WAAW;QACX,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;AAEJ","sourcesContent":[".baloa-play-full-video-modal.modal2 {\n    background-color: rgba(0, 0, 0, 0.9);\n}\n\n.baloa-play-full-video-modal .modal2__container {\n    width: 90%;\n    height: 90%;\n    box-shadow: none;\n}\n\n.baloa-play-full-video-modal .modal2__header {\n    background: transparent;\n    color: var(--white-color);\n    border-bottom: none;\n}\n\n.baloa-play-full-video-modal .modal2__header__title.baloa-subtitle-2 {\n    color: var(--white-color) !important;\n    font-size: 30px;\n    font-weight: 700;\n}\n\n.baloa-play-full-video-modal .modal2__header__close_icon {\n    color: var(--white-color);\n    padding: 5px;\n    background: var(--primary-dark-color);\n    border-radius: 50%;\n    font-size: 40px;\n}\n\n.baloa-play-full-video-modal .modal2__content {\n    background: transparent;\n    padding-top: 60px;\n}\n\n\n.baloa-play-full-video-modal__container{\n    display: flex;\n    align-items: flex-start;\n    gap: 10px;\n    width: 100%;\n    justify-content: space-between;\n}\n\n.baloa-play-full-video-modal__media-container {\n    position: relative;\n    width: 100%;\n    height: auto;\n}\n\n.baloa-play-full-video-modal__video-container {\n    position: relative;\n    width: 100%;\n    height: 100vh;\n    text-align: center;\n}\n\n.baloa-play-full-video-modal__slide-button {\n    height: 100%;\n    display: flex;\n    align-items: center;\n    width: 5%;\n    cursor: pointer;\n    z-index: 2;\n}\n\n.baloa-play-full-video-modal__slide-button.disabled{\n    opacity: 0.5;\n}\n\n.baloa-play-full-video-modal__slide-button .hubicon-arrow_circle_right {\n    font-size: 50px;\n    font-weight: var(--font-bold);\n    margin-left: auto;\n}\n\n.baloa-play-full-video-modal__slide-button .hubicon-arrow_circle_right .path1::before {\n    color: var(--primary-dark-color);\n}\n\n.baloa-play-full-video-modal__slide-button .hubicon-arrow_circle_left {\n    font-size: 50px;\n    font-weight: var(--font-bold);\n}\n\n.baloa-play-full-video-modal__slide-button .hubicon-arrow_circle_left .path1::before {\n    color: var(--primary-dark-color);\n}\n\n.baloa-play-full-video-modal__create-clip-button {\n    position: absolute;\n    top: 9vh;\n    left: 50%;\n    margin-left: -60px;\n    z-index: 2000;\n}\n\n.baloa-play-full-video-modal__create-clip-button .button {\n    width: 100%;\n    padding: 12px 24px;\n}\n\n.baloa-play-full-video-modal__create-clip-button .button .icon {\n    grid-area: icon;\n    margin-right: 8px;\n}\n\n.baloa-play-full-video-modal__create-clip-button .hubicon-video_library-1::before {\n    color: var(--white-color);\n}\n\n.baloa-play-full-video-modal__create-clip-widget__container {\n    background: var(--white-color);\n    border-radius: 8px;\n    padding: 18px;\n    min-width: 400px;\n}\n\n.baloa-play-full-video-modal__create-clip-widget__container .baloa-normal-medium {\n    text-align: center;\n    color: var(--primary-very-dark-color);\n}\n\n.baloa-play-full-video-modal__create-clip-widget__step {\n    margin-top: 16px;\n}\n\n.baloa-play-full-video-modal__create-clip-widget__step.baloa-names {\n    font-weight: var(--font-regular);\n    color: var(--primary-very-dark-color);\n}\n\n.baloa-play-full-video-modal__create-clip-widget__button {\n    margin-top: 16px;\n}\n\n.baloa-play-full-video-modal__create-clip-widget__button .button {\n    padding: 12px 24px;\n    width: 100%;\n}\n\n.baloa-play-full-video-modal__create-clip-widget__button .button .icon {\n    grid-area: icon;\n    margin-right: 8px;\n    justify-self: flex-end;\n}\n\n.baloa-play-full-video-modal__create-clip-widget__button .button.button-red {\n    background-color: #F1AEB5;\n    color: #B02A37;\n}\n\n.baloa-play-full-video-modal__create-clip-widget__button .hubicon-stop_circle::before {\n    color: #B02A37;\n    font-size: 24px;\n}\n\n.baloa-play-full-video-modal__create-clip-widget__counter {\n    border-radius: 4px;\n    background: var(--new-informative-banner-bg-color);\n    padding: 4px;\n    text-align: center;\n    width: 70%;\n    margin-left: auto;\n    margin-right: auto;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-top: 16px;\n}\n\n.baloa-play-full-video-modal__create-clip-widget__counter .baloa-table {\n    color: var(--primary-dark-color);\n    text-wrap: nowrap;\n}\n\n.baloa-play-full-video-modal__create-clip-widget__counter .baloa-table.seconds {\n    font-weight: var(--font-medium);\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */ \n\n    .baloa-play-full-video-modal .modal2__container {\n        width: 100%;\n        margin: 0;\n        height: 100%;\n        max-height: unset;\n    }\n\n    .baloa-play-full-video-modal .modal2__header {\n        justify-content: flex-end;\n        padding: 13px 15px;\n    }\n\n    .baloa-play-full-video-modal .modal2__header__title.baloa-subtitle-2 {\n        display: none;\n    }\n\n    .baloa-play-full-video-modal .modal2__header__close_icon {\n        background: none;\n        margin-left: auto;\n        padding: 0;\n        font-size: 24px;\n    }\n\n    .baloa-play-full-video-modal .modal2__content {\n        padding-top: 0;\n    }\n\n    .baloa-play-full-video-modal__media-container {\n        width: 90%;\n        height: inherit;\n    }\n\n    .baloa-play-full-video-modal__slide-button {\n        width: 5%;\n    }\n\n    .baloa-play-full-video-modal__slide-button .hubicon-arrow_circle_left {\n        font-size: 30px;\n        position: fixed;\n\n    }\n\n    .baloa-play-full-video-modal__slide-button .hubicon-arrow_circle_right {\n        font-size: 30px;\n        position: fixed;\n        right: 0px;\n    }\n\n    .baloa-play-full-video-modal__container {\n        gap: 0;\n        height: 90vh;\n    }\n\n    .baloa-play-full-video-modal__video-container {\n        width: 100%;\n        margin: auto;\n        height: 100%;\n    }\n\n    .baloa-play-full-video-modal__create-clip-widget__container {\n        position: absolute;\n        bottom: 0;\n        border-radius: 0;\n        min-width: unset;\n        width: 100%;\n        padding: 12px;\n    }\n\n    .baloa-play-full-video-modal__media-container.create-clip {\n        width: 100%;\n        height: 50vh;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
